import React from "react";
import mixpanel from "../../services/mixpanelService";
import useDeviceSizes from "../../services/hooks/useDeviceSizes";
import clsx from "clsx";

const HeadToHeadInfoCard: React.FC = () => {
  const { isMediumDevice } = useDeviceSizes();

  return (
    <div className="max-w-md p-4">
      <div className={clsx("p-6 border-2 border-black rounded-3xl mt-3", isMediumDevice ? "bg-soft-black" : "bg-grey/5")}>
        <div>
          <h2 className="font-primary text-base text-base-white mb-2">How it Works</h2>
          <p className="font-secondary text-grey text-sm mb-3">
            Help your favorite celebs and influencers win Head to Head fundraising challenges.
          </p>
          <p className="font-secondary text-grey text-sm mb-3">
            Choose a team to play and share for, helping them reach the donation goal, or raise the most money before time runs out.
          </p>
          <p className="font-secondary text-grey text-sm mb-3">Let’s see who has the most impactful fanbase!</p>
        </div>
        <div className="mt-6">
          <h2 className="font-primary text-base text-base-white mb-2">Suggest a match</h2>
          <p className="font-secondary text-grey text-sm mb-3">Tell us what celebs or influencers you want to see go head to head! 🤺</p>
          <a
            onClick={() => mixpanel.track("suggest-clicked", { location: "head-to-head-info" })}
            href="https://www.stashrun.com/suggest"
            target="_blank"
            rel="noreferrer"
            className="font-secondary text-primary-l1">
            Suggest a match
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeadToHeadInfoCard;
